





define([], function() {
    'use strict';

    return {
        or: function(value, defaultValue) {
            return value || defaultValue;
        },

        required: function(value, error) {
            if (value === undefined || value === null) {
                throw new TypeError(error);
            }
            return value;
        }
    };
});



// WEBPACK FOOTER //
// ./rest/utils.js